import { ArtistGroup } from "@max/common/artists";
import {
  documentId,
  limit,
  query,
  QueryDocumentSnapshot,
  where,
} from "firebase/firestore";
import { useEffect } from "react";
import { useCollectionOnce } from "react-firebase-hooks/firestore";
import { Ref } from "refs";

// Better UX by returning previously fetched records
const store: Record<string, QueryDocumentSnapshot<ArtistGroup>> = {};

interface Params {
  ids?: string[];
  limit?: number;
}

export const useArtistGroupsByIdsQuery = ({
  ids,
  limit: _limit = 4,
}: Params) => {
  const [artistGroups] = useCollectionOnce(
    ids?.length
      ? query(
          Ref("artist_groups"),
          where(documentId(), "in", ids),
          limit(_limit),
        )
      : null,
  );

  useEffect(() => {
    artistGroups?.docs.forEach((ap) => {
      store[ap.id] = ap;
    });
  }, [artistGroups]);

  return {
    artistGroups: Object.values(store)
      .filter((ag) => ids?.includes(ag.id))
      .map((ag) => ({ ...ag.data(), id: ag.id })),
  };
};
